import React from 'react';

export default function PageWrapper({ children, pageNumber, personName, showHeader = true, showFooter = true }) {
  return (
    <div className="pdf-page">
      <div className="pdf-page__content">
        {children}
      </div>
      {showFooter && (
        <div className="pdf-page__footer">
          <div className="pdf-page__footer-left">
            <span className="pdf-page__footer-company">Culturebie</span>
          </div>
          <div className="pdf-page__footer-center">
            {personName && <span>{personName}</span>}
          </div>
          <div className="pdf-page__footer-right">
            {pageNumber && <span>{pageNumber}</span>}
          </div>
        </div>
      )}
    </div>
  );
}
